import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';

import { ACTION_CODES } from 'constants/errors';
import { ADD_ADDITIONAL_DETAILS } from 'store/mutations';
import AgentPortalError from 'errors/AgentPortalError';
import { Spinner } from 'admin-components/components';
import { Row, Column } from 'components/shared/Layout';

import ExchangeCost from './ExchangeCost';
import { overrideExchangeFeesMutation } from './mutations';
import { bookingQuery } from '../queries';

const ExchangeCostContainer = ({ bookingReference, currency, errorRedirect, trainMarginDifference, ...props }) => {
  const [overrideExchangeFees, { loading: overrideExchangeFeesLoading, error: overrideExchangeFeesError }] = useMutation(
    overrideExchangeFeesMutation,
    {
      refetchQueries: [{ query: bookingQuery, variables: { reference: bookingReference, currency }, fetchPolicy: 'network-only' }],
      awaitRefetchQueries: true
    }
  );
  const [addAdditionalDetails, { loading: addAdditionalDetailsLoading, error: addAdditionalDetailsError }] =
    useMutation(ADD_ADDITIONAL_DETAILS);

  const loading = overrideExchangeFeesLoading || addAdditionalDetailsLoading;
  const error = overrideExchangeFeesError || addAdditionalDetailsError;

  if (loading) {
    return (
      <Row span={16}>
        <Column justifyContent="center" alignItems="center">
          <Spinner />
        </Column>
      </Row>
    );
  }

  if (error) {
    throw new AgentPortalError(error, ACTION_CODES.REDIRECT_TO_CUSTOM_PAGE, {
      errorCTARedirect: errorRedirect
    });
  }

  return (
    <ExchangeCost
      {...props}
      bookingReference={bookingReference}
      overrideFees={overrideExchangeFees}
      addAdditionalDetails={addAdditionalDetails}
      trainMarginDifference={trainMarginDifference}
      currency={currency}
    />
  );
};

ExchangeCostContainer.propTypes = {
  bookingReference: PropTypes.string,
  currency: PropTypes.string,
  errorRedirect: PropTypes.string,
  totalPointsForUpgradeWithPoints: PropTypes.number,
  trainMarginDifference: PropTypes.number
};

export default ExchangeCostContainer;
